import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@eatclubapp/ec-component-library';
import { Modal } from '../../../Modal/Modal';
import { Heading } from '../../../Heading';
import { useMediaQuery, useTheme } from '@mui/material';
import useStyles, { getModalStyles } from './EnquirySentModalStyles';
import CoinShineSVG from '../../../../assets/coin_shine.svg';

const EnquirySentModal = ({ isOpen, onClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const breakpointMdDown = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideFooter={true}
      style={getModalStyles(breakpointMdDown)}
    >
      <Box className={classes.enquirySentModalContainer}>
        <Box className={classes.enquirySentModalContent}>
          <Heading className={classes.enquirySentModalTitle}>Enquiry sent!</Heading>
          <Box className={classes.enquirySentModalDescription}>
            This credit spend request has been submitted and will be processed by your Account
            Manager.
          </Box>
        </Box>
        {!breakpointMdDown && (
          <Box className={classes.enquirySentModalImageContainer}>
            <CoinShineSVG className={classes.enquirySentModalImage} />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

EnquirySentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EnquirySentModal;
